import {
  activeBookingStatuses,
  CalendarContext,
  HolidayDialog,
  ModalActionKind,
  ReducerContext,
} from '@abdoo/common';
import { Grid } from '@mui/material';
import React, { useCallback, useContext } from 'react';

import { BookingItem } from '../BookingList/BookingItem';

export const HolidayBookingsModal = () => {
  const { refreshCalendarSummary, refreshHolidayBookings } = useContext(CalendarContext);
  const { modalState, modalDispatch } = useContext(ReducerContext);

  const updateHoliday = useCallback(() => {
    refreshCalendarSummary();
    modalDispatch({ type: ModalActionKind.CloseBookingSummary });
    refreshHolidayBookings();
  }, [modalDispatch, refreshCalendarSummary, refreshHolidayBookings]);

  const onModalClose = useCallback(() => {
    modalDispatch({ type: ModalActionKind.CloseBookingSummary });
  }, [modalDispatch]);

  return (
    <HolidayDialog
      closeDialog={onModalClose}
      open={modalState.isBookingSummaryOpen}
      closeDialogButton={onModalClose}
      title={'Holiday bookings'}
    >
      <>
        {modalState.bookingSummaryDays
          .filter((h) => activeBookingStatuses.includes(h.approvalStatus))
          .map((holiday, index) => (
            <Grid container item key={index} xs={12} md={12} justifyContent={'center'}>
              <Grid key={index} item xs={12} md={6}>
                <BookingItem
                  key={index}
                  holiday={holiday}
                  updateHoliday={updateHoliday}
                  isLoading={false}
                />
              </Grid>
            </Grid>
          ))}
      </>
    </HolidayDialog>
  );
};
